module.exports = __webpack_public_path__ + "static/media/jj_logo.213d6dce.png";